<template>
    <div v-if="myErrors.length">
        <small class="form-text text-danger" v-for="(value, index) in myErrors" :key="index">
            {{value}}
        </small>
    </div>
</template>

<script>
export default {
    props: ['name', 'errors'],
    computed: {
        err() {
            if (this.errors) {
                return this.errors
            }
            return this.$store.state.errors
        },
        myErrors() {
            if (typeof this.err === 'undefined'){
                return []
            }
            if (this.name in this.err) {
                return this.err[this.name]
            }
            return []
        },
    },
}
</script>
